import { array } from 'prop-types'
import NameAndPrice from '../../../atoms/ItemDetails/NameAndPrice'
import WithIndent from '../../../atoms/WithIndent'

const SubItems = ({ items }) => {
  if (!items) return null

  const subItems = items.map((item) => {
    return (
      <NameAndPrice
        id={item.id}
        key={item.id}
        name={item.name}
        price={item.price}
        prefixIcon={item.prefixIcon}
        suffixName={item.suffixName}
      />
    )
  })
  return <WithIndent>{subItems}</WithIndent>
}

export default SubItems

SubItems.propTypes = {
  items: array
}

SubItems.defaultProps = {
  items: null
}
